<template>
  <el-col class="data-section">
    <div class="header">
      <div class="info">
        <el-input
          size="mini"
          v-model="data.group_name"
          v-if="editSection"
          @change="editSection = false"
          :key="data.group_order"
        />
        <template v-else>
          {{ data.group_name }}
          <el-button
            icon="el-icon-edit-outline"
            @click="editSection = true"
            circle
            size="mini"
          />
        </template>
      </div>
      <div class="actions">
        <el-button icon="el-icon-d-caret" circle size="mini" />
        <el-button
          icon="el-icon-delete"
          @click="deleteSection()"
          circle
          size="mini"
        />
      </div>
    </div>

    <draggable-table>
      <el-table
        class="table"
        :data="data.attributes"
        stripe
        style="width: 100%"
      >
        <el-table-column label="Attribute">
          <template slot-scope="scope">
            {{ getRow(scope) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('Profiles_Overview_Label_Reorder')"
          width="100"
          align="center"
        >
          <i class="el-icon-d-caret"></i>
        </el-table-column>
        <el-table-column
          :label="$t('Profiles_Overview_Label_Remove')"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <i class="el-icon-delete" @click="deleteAttr(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </draggable-table>

    <div class="table-footer">
      <el-popover width="256" trigger="click">
        <el-select
          @visible-change="fetchAttributes(null)"
          @change="addAttr"
          v-model="newAttr"
          size="mini"
          filterable
          reserve-keyword
          :placeholder="$t('Profiles_Overview_Text_SelectAttribute')"
          remote
          :remote-method="fetchAttributes"
        >
          <el-option
            v-for="(item, index) in attributes.filter(filterOpt)"
            :key="index"
            :label="getTagName(item)"
            :value="item"
          />
        </el-select>
        <el-button
          slot="reference"
          icon="el-icon-circle-plus-outline"
          type="primary"
        >
          {{ $t('Profiles_Overview_Text_AddAttribute') }}
        </el-button>
      </el-popover>
    </div>
  </el-col>
</template>

<script>
import DraggableTable from '@/common/components/table/DraggableTable'
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'FeaturedAttributesSection',

  components: { DraggableTable },

  data() {
    return {
      newAttr: null,
      editSection: false,
      attributes: []
    }
  },

  props: {
    data: {
      type: Object,
      default: {}
    },
    categoryId: {
      type: Number,
      required: true
    },
    alreadySelectedAttributeNames: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    fetchAttributesEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `tags`
      })
    }
  },

  methods: {
    deleteSection() {
      this.$emit('delete-section')
    },

    filterOpt(opt) {
      const nameKey = typeof opt === 'object' && opt !== null ? opt.name : opt
      const alreadyInCategory = (
        this.alreadySelectedAttributeNames || []
      ).includes(nameKey)
      const alreadyInSection = (this.data.attributes || []).some(attr => {
        const attrName =
          typeof attr === 'object' && attr !== null ? attr.name : attr
        return attrName === nameKey
      })
      const alreadyInOtherSection = alreadyInCategory && !alreadyInSection
      return !alreadyInSection && !alreadyInOtherSection
    },

    getRow(scope) {
      return this.getTagName(scope.row)
    },

    deleteAttr(row) {
      this.$emit('delete-attr', row)
    },

    addAttr(attr) {
      this.$emit('add-attr', {
        name: attr.name,
        display_name: attr.display_name
      })
      this.newAttr = null
    },

    getTagName(tag) {
      return tag.name
    },

    fetchAttributes(query) {
      let params = {
        category_id: this.categoryId,
        attribute_profile: 1
      }
      if (query !== null && query !== '') {
        params['title'] = query
      }
      RestApi({
        ...this.fetchAttributesEndpoint,
        params: params
      })
        .then(({ data }) => {
          this.attributes = data
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  }
}
</script>

<style scoped lang="scss">
.data-section {
  margin: 8px 0;
  padding: 16px;
  background: #f8fafc;
  border: 1px solid #dbdee7;
  border-radius: 4px;
  .header {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
  }
  &.add-section {
    text-align: center;
  }
  .table-footer {
    padding: 10px;
    background-color: #ffffff;
    border: 1px solid #dbdee7;
    border-top: none;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }
}
/deep/ .el-table {
  box-shadow: inset 0px -1px 0px #ebeef5;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  border: 1px solid #dbdee7;
  border-bottom: none;
  .el-table__row {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/categorised-attributes/FeaturedAttributesSection.vue